import React from "react";
import {
  Col,
  Dialog,
  FabButton,
  Flex,
  Gap,
  InputField,
  Row,
  SelectField,
  Typography,
} from "../../ppui";
import { TbPencil } from "react-icons/tb";
import { OrganizationBx, OrganizationEmDetails } from "../style";
const StatutoryBankDetails = () => {
  // Modal
  const [setOpenBankingModal, setOpenStatutoryBANKINGModal] =
    React.useState(false);

  const handleOpenStatutoryBankingModal = () =>
    setOpenStatutoryBANKINGModal(true);
  const setOpenStatutoryBankingModal = () =>
    setOpenStatutoryBANKINGModal(false);
  // Modal
  return (
    <>
      <Flex justifyContent="space-between" gap={"10"}>
        <Typography mb={"0"} variant="h5">
          Bank List
        </Typography>

        <FabButton
          size="sm"
          icon={<TbPencil />}
          onClick={handleOpenStatutoryBankingModal}
          variant="filled"
          shape="box"
        />
      </Flex>
      <Gap height={30} />

      <OrganizationEmDetails>
        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Bank Name
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            SBI
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Branch Name
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Saltlake Sector-v
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Account No
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            67289342398557
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            IFSC No
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            SBIN0006794
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Account Type
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            savings
          </Typography>
        </OrganizationBx>

        <OrganizationBx>
          <Typography variant="body2" mb={"0"}>
            Primary Account
          </Typography>
          <Typography variant="body1" mb={"0"} color="primary">
            Yes
          </Typography>
        </OrganizationBx>
      </OrganizationEmDetails>

      {/*Modal */}
      <Dialog
        title="Bank List"
        closeButton={true}
        fullWidth
        maxWidth="sm"
        buttonName={"Update"}
        open={setOpenBankingModal}
        onClose={setOpenStatutoryBankingModal}
        onSubmit={() => alert("Submitted")}
        separator
      >
        <Row rowGap>
          <Col sm={6}>
            <InputField
              fullWidth
              label="Bank Name"
              placeholder="Type Here..."
              type="text"
              required
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Branch Name"
              placeholder="Type Here..."
              type="text"
              required
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="Account No"
              placeholder="Type Here..."
              type="number"
              required
            />
          </Col>

          <Col sm={6}>
            <InputField
              fullWidth
              label="IFSC No"
              placeholder="Type Here..."
              type="text"
              required
            />
          </Col>

          <Col sm={6}>
            <SelectField
              required
              fullWidth
              label="Account Type"
              options={[
                { id: "option1", name: "Current" },
                { id: "option2", name: "Saving" },
              ]}
              disabled
              placeholder="Select Here..."
            />
          </Col>
        </Row>
      </Dialog>
      {/*Modal */}
    </>
  );
};

export default StatutoryBankDetails;
